import { useLocation } from 'react-router-dom'

export const actOnData = (data, func) => (data && func(data)) || null

export const getDeep = (base, field, ...fields) => {
  if (field == null) {
    return base
  }
  if (!base || typeof base !== 'object') {
    return null
  }
  if (typeof field === 'string' && field.indexOf('.') !== -1) {
    return getDeep(base[field.split('.')[0]], ...field.split('.').splice(1))
  }
  return getDeep(base[field], fields[0], ...fields.splice(1))
}

export const getDeepOr = (defaultValue, base, field, ...fields) => {
  const deep = getDeep(base, field, ...fields)
  return deep != null ? deep : defaultValue
}

export const getQueryParams = (search = '') => {
  const params = {}
  search
    .replace(/^\?/g, '')
    .split('&')
    .map(param => param.split('='))
    .forEach(([key, value]) => {
      params[key] = value
    })
  return params
}

export const joinStrings =
  (...strings) =>
  separator =>
    strings.filter(c => !!c).join(separator)

export const classNames = (...classes) => joinStrings(...classes)(' ')

export const useQuery = () => getQueryParams(useLocation().search)

export const inIframe = () => {
  try {
    return window.self !== window.top
  } catch (e) {
    return true
  }
}

export const renderReadableDate = dateString => {
  const date = new Date(dateString)
  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  }
  return date.toLocaleString('sv-SE', options)
}
